import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import Title from '../../../components/Title';
import ContentsPreviewMobile from '../Preview/ContentsPreviewMobile';
import ContentsPreviewH from '../Preview/ContentsPreviewH';
import ContentsPreviewV from '../Preview/ContentsPreviewV';
import Pagination from '../../../components/Pagination';
import {
  getContentsDetail,
  getSlideList,
  getContentsList,
} from '../../../modules/NetworkFunction';
import AuthContext from '../../../contexts/AuthContext';
import DrawerContents from '../../../components/DrawerContents';
import closeIcon from '../../../icons/ic-close.png';
import { ReactComponent as TipIcon } from '../../../icons/ic-tip.svg';
import SelectContent from '../../../components/SelectContent';
import ShopModeContext from '../../../contexts/ShopModeContext';  

const MyContenteSelect = (props) => {
  const {
    closeModal,
    setPreviewModalClose,
    contentsNo,
    publishedContents = [],
    contentStyle,
    onSelectContentStyle = () => {},
    shopVersion,
    onSelect,
  } = props;
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);
  const [contentType, setContentType] = useState(
    contentStyle
      ? contentStyle
      : contentsNo && publishedContents[0]
      ? publishedContents[0].style
      : '배너 가로'
  );

  const [isMobile, setIsMobile] = useState(
    shopVersion
      ? shopVersion === 'mobile'
      : contentsNo && publishedContents[0]
      ? publishedContents[0].mobileYn
      : false
  );
  const [videoUrl, setVideoUrl] = useState();
  const [btnColor, setBtnColor] = useState('#000');
  const [fontColor, setFontColor] = useState('#ffffff');
  const [font, setFont] = useState('Noto Sans KR');
  const [btnBorderRadius, setBtnBorderRadius] = useState(0);
  const [slideList, setSlideList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isContentsLoaded, setisContentsLoaded] = useState(false);
  const [contentsList, setContentsList] = useState([]);
  const [selectedContentNo, setSelectedContentNo] = useState(null);
  let itemPerPage = 8; // 페이지별 영상 개수
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const totalItemsLength = contentsList.filter(info => info.shop === shopMode).length;
  const tempcontentsList = contentsList.filter(info => info.shop === shopMode)

  const contents = { contentsNo: contentsNo };

  const handleSelectContent = (contentsNo) => {
    setSelectedContentNo(contentsNo);
    console.log('selectedContentNo', selectedContentNo);
  };
  const handleClickSelectBtn = () => {
    props.onSelect(selectedContentNo);
    closeModal();
  };

  useEffect(() => {
    if (!isContentsLoaded) {
      getContentsList(
        null,
        (data) => {
          setContentsList(data);
        },
        setisContentsLoaded,
        (e) => {
          if (e) console.log(e);
        },
        token
      );
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  
  const contentItems = tempcontentsList.map((info, idx) => {


    if (windowWidth > 1454) {
      itemPerPage = 8;
    } else {
      itemPerPage = 4;
    }

    let start = (currentPage - 1) * itemPerPage;
    if (start <= idx && idx < start + itemPerPage) {
      if (info.shop === shopMode) {
      return (
        <SelectContent
          key={info.contentsNo}
          title={info.title}
          completeYn={info.completeYn}
          date={info.createDate}
          productCount={info.itemCount}
          thumbnail={info.thumbnail}
          isSelected={selectedContentNo === info.contentsNo}
          onClick={() => handleSelectContent(info.contentsNo)}
        />
      );
    }
    }
  });

  return (
    <div className="preview-page-modal">
      <div
        style={{
          width: '90%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <Title title="콘텐츠 선택" style={{ paddingTop: 66 }} />
        <CloseButton onClick={closeModal} />

        <div
          style={{
            width: '100%',
            display: 'flex',
            marginTop: 20,
            flexWrap: 'wrap',
          }}
        >
          {contentItems}
        </div>
        <div
          style={{
            marginTop: 50,
            position: 'absolute',
            bottom: 50,
            width: '100%',
          }}
        >
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemPerPage}
            totalItems={totalItemsLength}
            paginate={setCurrentPage}
            handleNextPageGroup={getContentsList}
          />
        </div>
        <SelectBtn onClick={handleClickSelectBtn}>선택</SelectBtn>
      </div>
    </div>
  );
};

const SelectBtn = styled.button`
  display: flex;
  position: absolute;
  width: 120px;
  height: 40px;
  border-radius: 20px;
  border: none;
  padding: 6px 6px;
  background-color: #ffb600;
  color: white;
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  border-width: 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 40px;
  bottom: 0;
  right: 0;
`;

const Selected = styled.div`
  position: absolute;
  width: 54px;
  height: 24px;
  font-size: 12px;
  top: 33%;
  left: 25%;
  color: #fff;
  background-color: #f76f20;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 2px 4px;
`;

const SelectedBack = styled.div`
  position: absolute;
  width: 97px;
  height: 97px;
  top: 4%;
  left: 6%;
  color: #fff;
  background-color: rgba(255, 122, 0, 0.2);
  border-radius: 7.12px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  padding: 2px 4px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 60px;
  right: 0px;
  width: 32px;
  height: 32px;
  background-image: url(${closeIcon});
  background-color: transparent;
  background-size: 100% 100%;
`;

export default MyContenteSelect;
